export enum LessonNavigationPossion {
  TOP = 'top',
  BOTTOM = 'bottom',
  INLINE = 'inline'
}
